import { Component, Input } from '@angular/core';
import { Components } from '@ionic/core';
import { addIcons } from 'ionicons';
import { downloadOutline } from 'ionicons/icons';
import { CloudFunctionsService } from 'src/services/cloudfunctions.service';
import { FirestoreService } from 'src/services/firestore.service';
import { UIService } from 'src/services/ui.service';
import { Transaction } from 'bankapp-types';
import { ModalController } from '@ionic/angular/standalone';
import * as xlsx from 'xlsx'
import saveAs from 'file-saver';
import { isBpayTotalBillPayment } from 'src/class/bpay';

@Component({
    selector: 'app-summary',
    templateUrl: 'summary.component.html',
    styleUrls: ['summary.component.scss']
})
export class SummaryComponent {


    @Input() modal: Components.IonModal;

    transactions = []
    bpayTransactions =[]

    uniqueRecon = []

    constructor(
        public firestoreService: FirestoreService,
        private cloud: CloudFunctionsService,
        private ui: UIService,
        private modalController: ModalController
    ) {
        addIcons({ downloadOutline });
    }


    async ngOnInit() {

        this.uniqueRecon = [...new Set(this.transactions.map(x => x.recon))]

        if(this.bpayTransactions?.length) {
            this.uniqueRecon = [...new Set([...this.uniqueRecon, ...this.bpayTransactions.map(x => x.recon)])]
        }
    }

    async downloadSummary() {

        const loading = await this.ui.presentLoading("Downloading...")

        const transactions = this.uniqueRecon.map(recon => {
            return {
                "Recon": recon || "Unreconciled",
                "Bpay Received": this.bpayTransactions.filter(x => x.recon == recon).reduce((acc, val) => acc + val.transaction, 0),
                "Total In": this.transactions.filter(x => x.recon == recon && !isBpayTotalBillPayment(x.narration) && x.transaction > 0).reduce((acc, val) => acc + val.transaction, 0),
                "Total Out": this.transactions.filter(x => x.recon == recon && x.transaction < 0).reduce((acc, val) => acc + val.transaction, 0),
                "Balance": this.bpayTransactions.filter(x => x.recon == recon).reduce((acc, val) => acc + val.transaction, 0) + this.transactions.filter(x => x.recon == recon && !isBpayTotalBillPayment(x.narration)).reduce((acc, val) => acc + val.transaction, 0)
            }
        })

        console.log(transactions)
        
        const ws = xlsx.utils.json_to_sheet(transactions);
        let wb = xlsx.utils.book_new();
        wb.Props = {
            Title: "Summary",
            Author: "Bank App",
            CreatedDate: new Date()
        };
        wb.SheetNames.push("Summary");
        wb.Sheets["Summary"] = ws;
        const wbout = xlsx.write(wb, { bookType: 'xlsx', type: 'binary' });
        saveAs(new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }), `${this.bpayTransactions?.length ? 'Bpay ' : ''}Summary.xlsx`);

        await loading.dismiss()
    }

    s2ab(s) {
        var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf);  //create uint8array as viewer
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;
    }
    

    dismissModal() {
        this.modal.dismiss()
    }

}
